export function initPressePage($) {
  // Animation page Presse
  $('.presse-page--element').on('mouseenter', function(){
    $('.presse-page--element').removeClass('is-active')
    $(this).addClass('is-active')
    let dataAttr = $(this).attr('data-postid');
    if($('.presse-page--img[data-postid='+dataAttr+']').length !== 0 ){
      $('.presse-page--img').removeClass('shown')
      if( !$('.presse-page--img[data-postid='+dataAttr+']').hasClass('shown') ){
        $('.presse-page--img[data-postid='+dataAttr+']').addClass('shown');
      } 
    }
  })
}
